export const DELAY_STATUS_GET = 2000;

export const PAYMENT_INSTRUCTION_TITLE = 'Платіжна інструкція';
export const CONSOLIDATED_PAYMENT_INSTRUCTION_TITLE = 'Зведена платіжна інструкція';

export const OTHER_PAYMENT_MIN_AMOUNT = 1;
export const OTHER_PAYMENT_MAX_AMOUNT = 5000;

export const HOST_CARD_MESSAGES = [
	'Менше комісія з HOSTCARD -',
	'З HOSTCARD комісія нижче -',
	'З HOSTCARD –',
	'З HOSTCARD комісія була б',
];
